import Language from '../types/language'
import daAntdStrings from './da_DK.antd'
import daStrings from './da_DK.strings'
import enAntdStrings from './en_GB.antd'
import enStrings from './en_GB.strings'

type lang = {
  strings: Record<string, string>
  antd: Record<string, unknown>
}

const langs: Record<Language, lang> = {
  [Language.DANISH]: { strings: daStrings, antd: daAntdStrings },
  [Language.ENGLISH]: { strings: enStrings, antd: enAntdStrings },
}
export function getStrings(language: Language): Record<string, string> {
  const lang = langs[language]
  if (!lang) {
    return daStrings
  }
  return lang.strings
}

export function getAntdStrings(language: Language): Record<string, any> {
  const lang = langs[language]
  if (!lang) {
    return daAntdStrings
  }
  return lang.antd
}
